import React from 'react'
import './App.css'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Signin from './pages/Signin'
import Signup from './pages/Signup'
import Contact from './pages/Contact'
import Home from './pages/Home'
import About from './pages/About'
import Header from './components/Header'
import Footer from './components/Footer'
import Countries from './pages/Countries'
import FAQs from './pages/FAQs'
import Community from './pages/Community'
import Terms from './pages/Terms'
import Courses from './pages/Courses'
import CountryDetails from './pages/CountryDetails'
import Business from './pages/Business'
import Skilling from './pages/Skilling'
import University from './pages/University'
import PrivacyPolicy from './pages/policy'
import Disclaimer from './pages/Disclaimer'
import CourseDetails from './pages/CourseDetails'
import Blog1 from './pages/Blog1'
import Blog2 from './pages/Blog2'
import Blog3 from './pages/Blog3'
import PopularCourses from './components/PopularCourses'
import RegisterForm from './pages/Registration'
import BlogDetails from './pages/BlogDetails'
import SkillingDetails from './pages/SkillingDetails'
import LanguageTraining from './pages/LanguageTraining'
import LanguageTrainingDetails from './pages/LanguageTrainingDetails'
import NursingGermany from './pages/NursingGermany'
import SvyasaLP from './pages/SvyasaLP'
import Counseling_page from './pages/Counseling_page'
import SASLanding from './pages/SASLanding'
import DataAIProgram from './pages/DataAIProgram'
import ClinicalProgram from './pages/ClinicalProgram'
import Studyworkdubai from './pages/StudyWorkDubaiLanding'
import StudyInJapanPage from './pages/StudyInJapanPage'
import CC30 from './pages/CC30'
import Sas_web from './pages/Sas_web'
import Assessments from './pages/Assessments'
import MbaInBangalore from './pages/MbaInBangalore'
import CompetencyAssessment from './pages/CompetencyAssessment'
import WorthTheYears from './pages/WorthTheYears'
import WhatsAppButton from './components/WhatsAppButton'
import MbbsAdmissions from './pages/MbbsAdmissions'

// Pricing Landing Pages
import CareerClarityLanding from './pages/pricing/CareerClarityLanding'
import UniThinkComprehensiveCounsellingLanding from './pages/pricing/UniThinkComprehensiveCounsellingLanding'
import UniThinkApplicationAdmissionSupportLanding from './pages/pricing/UniThinkApplicationAdmissionSupportLanding'
import UniThinkIndiaAdmissionGuidanceLanding from './pages/pricing/UniThinkIndiaAdmissionGuidanceLanding'
import UniThinkCountryFocusedAdmissionSupport from './pages/pricing/UniThinkCountryFocusedAdmissionSupport'
function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
    // Track virtual page views for Google Analytics
    if (window.gtag) {
      window.gtag('config', 'G-KZ2YRZ4GNZ', {
        page_path: pathname,
      });
    }
  }, [pathname])
  return null
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/signin' element={<Signin />} />
        <Route path='/signup' element={<Signup />} />

        <Route path='/countries' element={<Countries />} />
        <Route path='/faqs' element={<FAQs />} />
        <Route path='/community' element={<Community />} />

        <Route path='/terms' element={<Terms />} />
        <Route path='/disclaimer' element={<Disclaimer />} />
        <Route path='/courses' element={<Courses />} />
        <Route path='/skilling' element={<Skilling />} />
        <Route path='/university' element={<University />} />
        <Route path='/business' element={<Business />} />
        <Route path='/privacypolicy' element={<PrivacyPolicy />} />
        <Route path='/countrydetail/:countryid' element={<CountryDetails />} />
        <Route path='/coursedetail/:courseId' element={<CourseDetails />} />
        <Route path='/blog1' element={<Blog1 />} />
        <Route path='/blog2' element={<Blog2 />} />
        <Route path='/blog3' element={<Blog3 />} />
        <Route path='/registration' element={<RegisterForm />} />
        <Route path="/assessments" element={<Assessments />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/skillingdetails/:skillId" element={<SkillingDetails />} />
        <Route path='/languagetraining' element={<LanguageTraining />} />
        <Route path="/languagetrainingdetails/:languageId" element={<LanguageTrainingDetails />} />
        <Route path="/svyasa" element={<SvyasaLP />} />
        <Route path="/germany/nursing" element={<NursingGermany />} />
        <Route path="/counseling" element={<Counseling_page />} />
        <Route path="/sas" element={<SASLanding />} />
        <Route path="/sas/data-ai" element={<DataAIProgram />} />
        <Route path="/sas/clinical-programming" element={<ClinicalProgram />} />
        <Route path="/study-work-dubai" element={<Studyworkdubai />} />
        <Route path="/japan" element={<StudyInJapanPage />} />
        <Route path="/career-counseling" element={<CC30 />} />
        <Route path="/sas-webinar" element={<Sas_web />} />
        <Route path="/mba-in-bengaluru" element={<MbaInBangalore />} />
        <Route path="/competency-assessment" element={<CompetencyAssessment />} />
        <Route path="/worth-the-years" element={<WorthTheYears />} />
        <Route path="/events/3ds-of-design" element={<WorthTheYears />} />
        <Route path="/mbbs-admissions-india-abroad" element={<MbbsAdmissions />} />

        {/* Pricing Landing Pages */}
        <Route path="/pricing/career-clarity" element={<CareerClarityLanding />} />
        <Route path="/pricing/comprehensive-counselling" element={<UniThinkComprehensiveCounsellingLanding />} />
        <Route path="/pricing/application-admission-support" element={<UniThinkApplicationAdmissionSupportLanding />} />
        <Route path="/pricing/india-admission-guidance" element={<UniThinkIndiaAdmissionGuidanceLanding />} />
        <Route path="/pricing/country-focused-admission-support" element={<UniThinkCountryFocusedAdmissionSupport />} />



      </Routes>
      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  )
}

export default App

